var _ref2, _ref3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBedroom = function SvgBedroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 15,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "a"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fill: "none",
      d: "M0 0H20V15H0z"
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      clipPath: "url(#a)"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      width: 20,
      height: 2,
      rx: 1,
      transform: "translate(0 9)",
      fill: "#041f47"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      width: 2,
      height: 7,
      rx: 1,
      transform: "translate(0 8)",
      fill: "#041f47"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      width: 2,
      height: 10,
      rx: 1,
      fill: "#041f47"
    }),
    /*#__PURE__*/
    React.createElement("rect", {
      width: 2,
      height: 6,
      rx: 1,
      transform: "translate(18 9)",
      fill: "#041f47"
    }),
    /*#__PURE__*/
    React.createElement("circle", {
      cx: 2,
      cy: 2,
      r: 2,
      transform: "translate(4 3)",
      fill: "none",
      stroke: "#041f47",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }),
    /*#__PURE__*/
    React.createElement("g", {
      fill: "none",
      stroke: "#041f47",
      strokeMiterlimit: 10,
      strokeWidth: 2
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.571 2h4.858A2.571 2.571 0 0 1 20 4.571 3.429 3.429 0 0 1 16.571 8h-3.142A3.429 3.429 0 0 1 10 4.571 2.571 2.571 0 0 1 12.571 2z",
      stroke: "none"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      d: "M12.6 3h4.8A1.6 1.6 0 0 1 19 4.6 2.4 2.4 0 0 1 16.6 7h-3.2A2.4 2.4 0 0 1 11 4.6 1.6 1.6 0 0 1 12.6 3z"
    })))))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgBedroom, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/bedroom.efe6e114.svg";
export { ForwardRef as ReactComponent };